import { cumulativeOffset } from '../utils/dom-utils';

const localNav = () => {
  const slimHeaderDiv = document.querySelector('.header');
  if (slimHeaderDiv === null) {
    return;
  }
  const inPageNavDiv = document.querySelector('.c-localNav');
  if (inPageNavDiv === null) {
    return;
  }
  const headerDiv = document.querySelector('.header');
  const headerContentDiv = document.querySelector('.header-main-section');
  const contentDiv = document.querySelector('.o-notchHeader__content');
  const mobileBrkpt = 768;
  let inPageNavYPos = cumulativeOffset(inPageNavDiv).top;
  // inelegant fix for waiting for slider code to run
  setTimeout(() => {
    inPageNavYPos = cumulativeOffset(inPageNavDiv).top;
  }, 100);

  const updateOffsetHeight = () => {
    // No fixed header on "mobile"
    if (window.innerWidth <= mobileBrkpt) {
      return;
    }
    if (headerContentDiv && headerDiv) {
      let headerFixedOffset = 0;
      const headerOffset = headerContentDiv.clientHeight;
      const addFixedAtY = inPageNavYPos - headerOffset;
      // console.log(`${addFixedAtY}/${window.pageYOffset}, inPageNavYPos: ${inPageNavYPos}`);
      if (addFixedAtY <= window.pageYOffset) {
        headerFixedOffset = Math.min(window.pageYOffset - addFixedAtY, headerContentDiv.offsetHeight) * -1;
        headerDiv.style.top = `${headerFixedOffset}px`;
      } else {
        headerDiv.removeAttribute('style');
      }
    }
    if (inPageNavDiv && inPageNavYPos <= window.pageYOffset) {
      if (contentDiv) {
        contentDiv.style.paddingTop = `${inPageNavDiv.offsetHeight}px`;
      }
      inPageNavDiv.classList.add('is-fixed');
    } else {
      if (contentDiv) {
        contentDiv.removeAttribute('style');
      }
      inPageNavDiv.classList.remove('is-fixed');
    }
  };

  window.addEventListener('scroll', () => {
    updateOffsetHeight();
  });

  window.addEventListener('resize', () => {
    inPageNavYPos = cumulativeOffset(inPageNavDiv).top;
  });
  updateOffsetHeight();
};

export default localNav;
